import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ isFormLocked?: boolean }>()(
  (theme, { isFormLocked }) => ({
    formContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(5),
      marginBottom: theme.spacing(16),
    },
    actions: {
      display: 'flex',
      gap: theme.spacing(3),
      width: isFormLocked ? '30%' : '100%',
      justifyContent: 'flex-end',
      zIndex: 500,
      position: 'relative',
    },
    onboardingFooter: {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-end',
    },
    onboardingFooterWithLoader: {
      justifyContent: 'space-between !important',
    },
    loading: {
      display: 'flex',
      gap: theme.spacing(1),
      alignItems: 'center',
    },
    loadingText: {
      fontSize: '14px',
      color: theme.palette.labraText.description,
    },
    productCount: {
      fontFamily: `${theme.typography.fontFamily} !important`,
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: ' 20px',
      letterSpacing: '0.25px',
      color: theme.palette.labraText.tertiary,
    },
    onboardingActions: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
    },
    autosave: {
      display: 'flex',
      alignItems: 'center',
    },
    btnWrapper: {
      display: 'flex',
      gap: theme.spacing(2),
    },
    formDisabled: {
      zIndex: 100,
      position: 'relative',
      opacity: 0.7,
      cursor: 'not-allowed',
    },
    modalText: {
      fontSize: '14px !important',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px !important',
      letterSpacing: '0.25px',
      color: theme.palette.labraText.description,
      fontFamily: theme.typography.fontFamily,
      textAlign: 'left',
    },
    nameBoldText: {
      fontSize: '14px !important',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '20px !important',
      letterSpacing: '0.1px',
      color: theme.palette.labraText.description,
      fontFamily: theme.typography.fontFamily,
      textAlign: 'left',
    },
    lockStatusMsg: {
      width: '70%',
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
    userName: {
      fontWeight: 600,
    },
    disableBtn: {
      cursor: 'not-allowed',
    },
    disableEvents: {
      pointerEvents: 'none',
    },
    root: {
      height: theme.spacing(8),
      padding: theme.spacing(1.5, 5),
    },
  })
)
